import axios from "axios";
import { GrConsole } from "react-icons/gr";

// let baseURL = "http://localhost:5282/api"; // پیش‌فرض برای لوکال

// const hostname = window.location.hostname;

// if (hostname === "172.30.11.101") {
//   baseURL = "https://172.30.11.101/api"; // سرور اصلی
// } else if (hostname === "172.30.12.17") {
//   baseURL = "https://172.30.12.17/api"; // تست اول
// } else if (hostname === "172.30.12.18") {
//   baseURL = "https://172.30.12.18/api"; // تست دوم
//   // baseURL="http://localhost:5282/api"
// } else if (hostname === "87.107.111.33") {
//   baseURL = "https://87.107.111.33/api"; // تست دوم
// } else if (hostname === "panel.doosheh.com") {
//   baseURL = "https://panel.doosheh.com/api"; // تست دوم
// }

let baseURL = "";
const hostname = window.location.hostname;

if (hostname === "84.245.19.164") {
  baseURL = "http://84.245.19.164/api";
} 
else if (hostname === "172.30.12.17") {
  baseURL = "http://172.30.12.17/api";
} 
else if (hostname === "www.salesordering.com")
{
  baseURL = "https://www.salesordering.com/api";
}
else if (hostname === "http://www.salesordering.com/")
{
  baseURL = "http://www.salesordering.com/api"
}
//else if (hostname === "172.30.12.18") {
//   baseURL = "https://172.30.12.18";
// } else if (hostname === "87.107.111.33") {
//   baseURL = "https://87.107.111.33";
// } else if (hostname === "panel.doosheh.com") {
//   baseURL = "https://panel.doosheh.com";
// }
else if (hostname === "localhost") {
  baseURL = "http://localhost:5282/api";
  //baseURL = "http://localhost/api";
}

const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ← بلوک جدید: مدیریت متمرکز خطای عدم دسترسی
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      debugger;
      const lang = localStorage.getItem("language") || "fa";
      const forbiddenMessages = {
        fa: "شما دسترسی به انجام این عملیات را ندارید.",
        ar: "لا تملك صلاحية لتنفيذ هذه العملية.",
      };
      const msg = forbiddenMessages[lang] || forbiddenMessages.fa;

      const originalData = error.response.data;

      if (originalData && typeof originalData === "object") {
        // شکل آبجکتی رو حفظ می‌کنیم و همه‌ی کلیدهای رایج پیام رو پر می‌کنیم
        // (چون بعضی صفحات .message و بعضی .Message می‌خونن)
        error.response.data = {
          ...originalData,
          message: msg,
          Message: msg,
          Success: false,
          success: false,
        };
      } else {
        // شکل رشته‌ای ساده
        error.response.data = msg;
      }
    }

    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("userName");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;